import React from 'react';
import T from '../misc/t';

require('stylesheets/leaflet/popup');

class MarkerPopup extends React.Component {
  render() {
    let popup;
    if (this.props.type === 'structure') {
      popup = (<div>
          <h3><T k="popup.header" /></h3>
          <br/>
          <T k="popup.title" /> : {this.props.title}
          <hr></hr>
          <T k="popup.donors" /> : {this.props.donors}
        </div>);
    } else {
      popup = (<div>
          <h3><T k="popup.header" /></h3>
          <T k="popup.project_id" /> : {this.props.projectid}
          <br/>
          <T k="popup.project_title" /> : {this.props.title}
          <hr></hr>
          <T k="popup.project_description" /> : {this.props.description}
          <br/>
          <T k="popup.project_objectives" /> : {this.props.objetives}
          <br/>
          <T k="popup.donor" /> : {this.props.donor}
          <br/>
          <T k="popup.program" /> : {this.props.program}
          <br/>
          <T k="popup.status" /> : {this.props.status}
          <br/>
          <T k="popup.implementing_agency" /> : {this.props.implagency}
          <br/>
          <T k="popup.duration" /> : {this.props.duration}
          <br/>
          <T k="popup.funding_type" /> : {this.props.fundingtype}
          <br/>
          <T k="popup.draft_estimated" /> : {this.props.draftestimates}
          <br/>
          <T k="popup.total_estimates_for_2015" /> : {this.props.totalestimated}
        </div>);
    }
    return (
      <div className = "projectinfo">
        {popup}
      </div>
    );
  }
}

MarkerPopup.propTypes = {
  projectid: React.PropTypes.string.isRequired,
  title: React.PropTypes.string.isRequired,
  draftestimates: React.PropTypes.string.isRequired,
  duration: React.PropTypes.string.isRequired,
  donor: React.PropTypes.string.isRequired,
  fundingtype: React.PropTypes.string.isRequired,
  status: React.PropTypes.string.isRequired,
  implagency: React.PropTypes.string.isRequired,
  program: React.PropTypes.string.isRequired,
  description: React.PropTypes.string.isRequired,
  objetives: React.PropTypes.string.isRequired,
  totalestimated: React.PropTypes.string.isRequired,

};

export default MarkerPopup;



/** WEBPACK FOOTER **
 ** ./app/scripts/components/map/MarkerPopup.jsx
 **/